import { getFmvValue, getQtyValue } from "../data/data";

const normalizeOperator = (operator) => {
  if (operator == null || operator === "") return undefined;
  if (typeof operator === "object" && operator.value != null) {
    return operator.value;
  }
  return operator;
};

/**
 * Build API dynamic_filters for FMV and QTY comparison filters.
 * Accepts flat operator strings (from action payload) or select objects (from filterData).
 */
export const buildInventoryDynamicFilters = ({
  fmv_operator,
  fmv_value,
  fmv_start,
  fmv_end,
  qty_operator,
  qty_value,
  qty_start,
  qty_end,
} = {}) => {
  const fmvOp = normalizeOperator(fmv_operator);
  const qtyOp = normalizeOperator(qty_operator);

  if (!fmvOp && !qtyOp) return undefined;

  return {
    suggested_fmv_with_vq: fmvOp
      ? {
          operator: fmvOp,
          value: getFmvValue({
            fmv_operator: fmvOp,
            fmv_value,
            fmv_start,
            fmv_end,
          }),
        }
      : undefined,
    qty_available: qtyOp
      ? {
          operator: qtyOp,
          value: getQtyValue({
            qty_operator: qtyOp,
            qty_value,
            qty_start,
            qty_end,
          }),
        }
      : undefined,
  };
};

export const buildInventoryDynamicFiltersFromFilterData = (filterData) =>
  buildInventoryDynamicFilters({
    fmv_operator: filterData?.fmv_operator,
    fmv_value: filterData?.fmv_value,
    fmv_start: filterData?.fmv_start,
    fmv_end: filterData?.fmv_end,
    qty_operator: filterData?.qty_operator,
    qty_value: filterData?.qty_value,
    qty_start: filterData?.qty_start,
    qty_end: filterData?.qty_end,
  });

/** Prefer pre-built dynamic_filters from action payload; otherwise build from flat fields. */
export const resolveInventoryDynamicFilters = (params = {}) =>
  params.dynamic_filters ?? buildInventoryDynamicFilters(params);
